/* ------------------------------------------------------------------ */
/*  Course registry — one entry per course, keyed by slug              */
/*                                                                    */
/*  Content (modules/lessons) lives in per-course JSON data files,    */
/*  built through the courseData factory. The DB mirrors it via       */
/*  scripts/generate-seed.ts; `dbId` is the D1 courses.id.            */
/*                                                                    */
/*  Two different "published" signals exist on purpose:               */
/*    - registry `isPublished` (here): is the course LISTED publicly  */
/*      on the landing page? The Control Loop is true — a public      */
/*      syllabus teaser.                                              */
/*    - registry `dbIsPublished`: the value scripts/generate-seed.ts  */
/*      writes to DB `courses.is_published` — is course CONTENT       */
/*      available, i.e. listed on the subscriber dashboard? TCL stays */
/*      0 until launch. Keep it in sync with the landing flag only    */
/*      when a course genuinely launches.                             */
/*  Module-level `isPublished` in the JSON marks per-module content   */
/*  availability ("coming soon" modules).                             */
/* ------------------------------------------------------------------ */

import { buildCourseContent, courseContent } from "./courseData";
import type { CourseContent } from "./courseData";
import tclData from "./theControlLoop.json";

export type CourseRegistryEntry = CourseContent & {
  dbId: string;
  isPublished: boolean;
  dbIsPublished: 0 | 1;
};

const tcl = buildCourseContent(tclData, {
  slug: "the-control-loop",
  title: "The Control Loop",
  description:
    "One real build, from understanding what to build to shipped product.",
  thumbnailUrl: "https://assets.foyzul.com/aswe-lms/the-control-loop.webp",
}, "cl-");

export const courseRegistry: Record<string, CourseRegistryEntry> = {
  [courseContent.course.slug]: { dbId: "course-ase", isPublished: true, dbIsPublished: 1, ...courseContent },
  [tcl.course.slug]: { dbId: "course-tcl", isPublished: true, dbIsPublished: 1, ...tcl },
};

export function getCourseContent(slug: string): CourseRegistryEntry | undefined {
  return courseRegistry[slug];
}

// Landing-page listing filter — the public card list reads this, not the
// DB flag. Kept as a function (not inlined at the call site) so the
// listed set is directly testable.
export function publishedCourses(
  entries: CourseRegistryEntry[] = Object.values(courseRegistry)
): CourseRegistryEntry[] {
  return entries.filter((e) => e.isPublished);
}
